import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { GoogleLogo, Lock, ShieldCheck } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  useEffect(() => {
    if (!loading && user) navigate("/admin", { replace: true });
  }, [user, loading, navigate]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0B1E45] px-5">
      <div className="w-full max-w-md bg-white rounded-sm border-t-4 border-[#46A01E] shadow-2xl p-8 lg:p-10">
        <div className="flex items-center gap-2 text-[#46A01E] font-display font-bold uppercase tracking-widest text-xs mb-4">
          <span className="h-px w-8 bg-[#46A01E]" /> Owner Portal
        </div>
        <div className="font-display font-black text-3xl tracking-tighter text-[#15306E] mb-2">
          CleanOut<span className="text-[#46A01E]">247</span> Admin
        </div>
        <p className="text-[#52525B] text-sm leading-relaxed mb-8">
          Sign in with your authorized Google account to manage leads, reviews, and your work gallery.
        </p>

        <button
          data-testid="admin-google-login-button"
          onClick={login}
          className="w-full flex items-center justify-center gap-3 bg-[#15306E] hover:bg-[#46A01E] text-white font-display font-extrabold uppercase tracking-wide text-sm py-4 rounded-sm transition-colors"
        >
          <GoogleLogo size={20} weight="bold" /> Sign in with Google
        </button>

        <div className="mt-8 space-y-3 text-sm text-[#52525B]">
          <div className="flex items-center gap-2">
            <Lock size={16} weight="fill" className="text-[#46A01E]" /> Restricted to authorized accounts only
          </div>
          <div className="flex items-center gap-2">
            <ShieldCheck size={16} weight="fill" className="text-[#46A01E]" /> Secure session, expires after 7 days
          </div>
        </div>
      </div>
    </div>
  );
}
